export const defaultUserState = {
  id: null,
  role: null,
  profile: null,
  club:null,
  jwt: null,
  clubs:null,
  clubUser:null,
}